import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DividerComponent, TileComponent } from '@tecalisdev/infinity';
import { PwcsInlineSvgComponent } from 'src/app/shared/components/pwcs-inline-svg/pwcs-inline-svg.component';

@Component({
	selector: 'app-dynamic-form-help',
	imports: [TranslatePipe, DividerComponent, TileComponent, PwcsInlineSvgComponent],
	templateUrl: './dynamic-form-help.component.html',
	styleUrl: './dynamic-form-help.component.scss',
})
export class DynamicFormHelpComponent {}
